export enum DisplayMode {
  phone = "phone",
  tablet = "tablet",
  desktop = "desktop",
}
